import React from 'react';
import { useTranslation } from 'react-i18next';

import * as List from 'components/list';
import * as Tabs from 'components/tabs';

import * as Styled from './StyledCXISupport';

export const CXISupport = () => {
    const { t } = useTranslation('cxi');

    // Create the secondary actions options
    const actions = [
        {
            as: 'a',
            icon: 'fab fa-whatsapp',
            href: 'https://wa.me/551135005001',
            text: t('support.whatsapp'),
        },
        {
            as: 'a',
            icon: 'fab fa-facebook-messenger',
            href: 'http://www.facebook.com/messages/t/1616610695217236',
            text: t('support.messenger'),
        },
        {
            as: 'a',
            icon: `far fa-envelope`,
            href: 'mailto:helpme@openstartups.net',
            text: t('support.email'),
        },
    ];

    return (
        <Styled.CXISupport name="CXISupport" back={false}>
            <Tabs.TabsContainer>
                <Tabs.TabsButtons>
                    <Tabs.Tab name="steps">{t('support.tab.steps')}</Tabs.Tab>
                    <Tabs.Tab name="video">{t('support.tab.video')}</Tabs.Tab>
                </Tabs.TabsButtons>

                <div className="tab-view" name="steps">
                    <p>Para começar a utilizar, clique no botão Encontrar Startups.</p>
                    <p>
                        Você será direcionado para uma página onde receberá sugestões de startups
                        que se adequam ao perfil que você selecionou ao ingressar no programa pela
                        primeira vez. Para mais informações sobre uma solução, clique em Veja Mais.
                    </p>
                    <p>
                        Para realizar um match, basta clicar no botão cujo polegar está para cima
                        (ou Like). Se acha que a startup não se adequa às necessidades da sua
                        empresa, aperta no botão cujo polegar está para baixo (ou dislike).{' '}
                    </p>
                    <p>
                        Depois de realizar um match com uma startup, o próximo passo é avaliá-la.
                        Você pode fazer isso logo após clicar no botão de like, respondendo sim
                        quando perguntado se deseja avaliar o potencial da startup; ou, clicando no
                        botão Classificar em Minha Rede.
                    </p>
                    <p>
                        Uma vez classificando a startup, você deve aguardar enquanto ela avalia o
                        feedback que você enviou. Quando isso acontecer, você poderá solicitar
                        Speed-Datings, reuniões de até 18 minutos que acontecem durante a Oiweek; ou
                        iniciar um processo de aconselhamento e mentoria com ela.
                    </p>
                </div>

                <div className="tab-view" name="video">
                    <div className="iframe-video">
                        <iframe
                            src="https://www.youtube-nocookie.com/embed/_Tlp8FWGC9M?controls=0"
                            title="Como começar a contribuir com Startups"
                        />
                    </div>
                    <p>
                        Caso este tutorial não tenha sanado suas dúvidas ou você esteja enfrentando
                        algum outro tipo de dificuldade, fale conosco através dos canais abaixo:
                    </p>
                </div>
            </Tabs.TabsContainer>

            <List.List name="PagesSupportList">
                <List.Vertical items={actions} itemKey="icon" />
            </List.List>
        </Styled.CXISupport>
    );
};
